export default __webpack_public_path__ + "static/Gloomy-1d83c8b2ff82205b05b7526ee24b41b1.png";